module.exports = __webpack_public_path__ + "53837a1e87eb47fe0e7c983c84b2fdb1.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/App/screens/Tube/screens/Index/components/banner/images/banner.jpg
 ** module id = 2731
 ** module chunks = 72
 **/